import { PropsWithChildren, ReactElement } from 'react';
import { useRouter } from 'next/router';
import { isApp } from '@zep/utils';
import { Footer } from './Footer';
import { Header } from './Header';
export const DefaultLayout = (props: PropsWithChildren) => {
  const {
    children
  } = props;
  const router = useRouter();
  if (isApp() || router.pathname.split('/')[1] === 'notfound') {
    return <>{children}</>;
  }
  return <>
      <Header data-sentry-element="Header" data-sentry-source-file="DefaultLayout.tsx" />
      {children}
      <Footer data-sentry-element="Footer" data-sentry-source-file="DefaultLayout.tsx" />
    </>;
};
export const getDefaultLayout = (page: ReactElement) => <DefaultLayout data-sentry-element="DefaultLayout" data-sentry-component="getDefaultLayout" data-sentry-source-file="DefaultLayout.tsx">{page}</DefaultLayout>;